import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import initialState from './invoicesListInitialState';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getInvoices = createAsyncThunk(
  'stop/getInvoices',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data;
    return data === undefined ? null : data;
  }
);

const invoicesSlice = createSlice({
  name: 'stop/invoices',
  initialState,
  reducers: {
    resetInvoices: (state) => initialState,
  },
  extraReducers: {
    [getInvoices.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetInvoices } = invoicesSlice.actions;
export default invoicesSlice.reducer;
